import api from '@/api/api';

const DOMAIN = '/employees';
const DOMAIN_COMPANIES = '/companies';

const get = async (
	params?: Employees.EmployeeParams,
): Promise<Employees.GetEmployeesResponse> => {
	const { data } = await api.get(`${DOMAIN_COMPANIES}/employees`, { params });
	return data;
};

const getByCompany = async (
	companyId: string,
	params?: Employees.EmployeeParams,
): Promise<Employees.GetEmployeesResponse> => {
	const { data } = await api.get(
		`${DOMAIN_COMPANIES}/${companyId}/employees`,
		{
			params,
		},
	);
	return data;
};

const getStats = async (): Promise<Employees.EmployeeStats> => {
	const { data } = await api.get(`${DOMAIN_COMPANIES}/employees/stats`);
	return data;
};

const getStatsByCompany = async (
	companyId: string,
): Promise<Employees.EmployeeStats> => {
	const { data } = await api.get(
		`${DOMAIN_COMPANIES}/${companyId}/employees/stats`,
	);
	return data;
};

const create = async (body: Employees.Create): Promise<Employees.Employee> => {
	const { data } = await api.post(`${DOMAIN}`, body);
	return data;
};

const bulkCreate = async (body: Employees.BulkCreate): Promise<void> => {
	await api.post(`${DOMAIN}/bulk`, body);
};

const patch = async (
	id: string,
	body: Employees.Update,
): Promise<Employees.Employee> => {
	const { data } = await api.patch(`${DOMAIN}/${id}`, body);
	return data;
};

const patchOrganizationLink = async (
	id: string,
	body: Employees.PatchOrganizationLinkBody,
): Promise<Employees.Employee> => {
	const { data } = await api.patch(`${DOMAIN}/${id}`, body);
	return data;
};

const remove = async (id: string): Promise<void> => {
	await api.delete(`${DOMAIN}/${id}`);
};

const updateStatus = async (
	id: string,
	body: { active: boolean },
): Promise<void> => {
	await api.patch(`${DOMAIN}/${id}/status`, body);
};

const linkToUser = async (id: string, userId: string): Promise<void> => {
	await api.post(`${DOMAIN}/${id}/link/${userId}`);
};

const unlinkFromUser = async (id: string): Promise<void> => {
	await api.delete(`${DOMAIN}/${id}/link`);
};

/** Colaborador em `/empresa/formulario/:companyId` — sem senha. */
const login = async (
	body: Employees.Login,
): Promise<Employees.LoginResponse> => {
	const { data } = await api.post(`${DOMAIN}/login`, body);
	return data;
};

const getMe = async (): Promise<Employees.EmployeeMe> => {
	const { data } = await api.get(`${DOMAIN}/me`);
	return data;
};

const EmployeeService = {
	get,
	getByCompany,
	getStats,
	getStatsByCompany,
	create,
	bulkCreate,
	patch,
	patchOrganizationLink,
	remove,
	updateStatus,
	linkToUser,
	unlinkFromUser,
	login,
	getMe,
};

export { EmployeeService };
